import tealium from '../tealium';

export function init() {
  // Teester loading and tracking
  window.onTeesterReady = window.onTeesterReady || [];
  window.TeesterSDK = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.onTeesterReady.push((SDK: any) => {
    window.TeesterSDK = SDK;
  });
  window.teesterPlayer = false;
  window.teesterTracker = false;

  function trackTeesterEvent(
    event: string,
    videoId: string,
    videoLengthSec?: undefined,
    videoLengthPercent?: undefined,
  ) {
    const trackingObj = {
      event_name: 'teester',
      event_category: 'teester',
      event_action: event,
      event_label: videoId,
      video_id: videoId,
      video_platform: 'teester',
      video_playhead: undefined,
      video_milestone: undefined,
    };
    if (videoLengthSec !== undefined) {
      trackingObj.video_playhead = videoLengthSec;
    }
    if (videoLengthPercent !== undefined) {
      trackingObj.video_milestone = videoLengthPercent;
    }
    tealium.evtLink(trackingObj);
  }

  window.testTeesterVideo = function (skuBaseId, playerClass, playerId) {
    window.resetTeester(playerId);
    const teesterPlayerKey = window.utag_data.teester_player_id;
    const teesterTrackingKey = window.utag_data.teester_tracking_key;
    const videoId = 'SKU' + skuBaseId;
    if (window.TeesterSDK !== false) {
      window.TeesterSDK.checkVideoAvailability(
        teesterPlayerKey,
        videoId,
        (value: boolean) => {
          if (value === false) {
            document.querySelector(playerClass)?.classList.add('hidden');
          } else {
            document.querySelector(playerClass)?.classList.remove('hidden');
            window.teesterTracker = window.TeesterSDK.init({
              type: 'tracking',
              args: {
                key: teesterTrackingKey,
                product: videoId,
                event: 'PRODUCT_PAGE_VIEW',
              },
            });
          }
        },
      );
    }
  };

  window.resetTeester = function (playerId) {
    if (window.teesterPlayer !== false) {
      window.teesterPlayer.pause();
      const player = document.querySelector(playerId);
      if (player) {
        player.classList.remove('teester-parsed');
        player.innerHTML = '';
      }
    }
  };

  window.updateTeester = function (skuBaseId, playerId) {
    const teesterPlayerKey = window.utag_data.teester_player_id;
    const videoId = 'SKU' + skuBaseId;
    if (window.TeesterSDK !== false) {
      window.resetTeester(playerId);
      window.teesterPlayer = window.TeesterSDK.init(
        {
          type: 'player',
          args: {
            key: teesterPlayerKey,
            product: videoId,
            width: '100%',
            height: 'auto',
          },
        },
        document.querySelector(playerId),
      );

      window.teesterPlayer.onPlay(() => {
        trackTeesterEvent('video_start', videoId);
      });
      window.teesterPlayer.onPause(() => {
        trackTeesterEvent('video_pause', videoId);
      });
      window.teesterPlayer.onEnded(() => {
        trackTeesterEvent('video_stop', videoId);
      });
    }
  };
}
